
  import AddonPromo from '@/ui/components/addons/AddonPromo.vue';
  import { defineComponent } from 'vue';

  export default defineComponent({
    components: {
      AddonPromo,
    },
  });
